import { ID } from '../model/baseentity';

export interface RestApiInfo {
    action?: string;
    actionName?: string;
    url?: string;
    httpMethod?: string;

    fullUrl?: string;
}
export interface EntityApi extends RestApiInfo {
    entityName?: string;
    entityTitle?: string;
}

export interface EntityInfo {
    entityName?: string;
    entityTitle?: string;
    baseUrl?: string;
    tableName?: string;
    className?: string;
    idProp?: string;
    nameProp?: string;
    sortProp?: string;

    apis?: EntityApi[]
}

export interface IEntityNameValue {
    name?: string;

    value?: any;
}


export enum EntityPropType {
    ENTITY_PROPTYPE_STR = 'C',
    ENTITY_PROPTYPE_DATE = 'D',
    ENTITY_PROPTYPE_NUM = 'N',
    ENTITY_PROPTYPE_REF = 'REF',
}

export interface EntityPropMetadata {
    /**
     * å±æ§åç§°
     */
    propName?: string;

    /**
     * å±æ§ç±»åï¼C/D/N/REF
     */
    propType?: EntityPropType;

    /**
     * ç¨äºæ¾ç¤ºçå±æ§åç§°
     */
    propTitle?: string;

    /**
     * æ¯å¦ç¶èç¹
     */
    isParent?: boolean;

    /**
     * æ¯å¦åé¨ç¼ç èç¹
     */
    isInnercode?: boolean;
    /**
     * æ¯å¦å¿é¡»
     */
    required?: boolean;
    /**
     * æå°é¿åº¦
     */
    minLength?: number;

    /**
     * æå¤§é¿åº¦
     */
    maxLength?: number;

    /**
     * æå°å¼
     */
    minValue?: any;

    /**
     * æå¤§å¼
     */
    maxValue?: any;

    /**
     * ç²¾åº¦(å°æ°ä½æ°)
     */
    precision?: number;

    /**
     * æ­£åå¹é
     */
    pattern?: string;

    /**
     * æ¥ææ ¼å¼
     */
    format?: string;

    /**
     * å¯éå¼åè¡¨
     */
    listValues?: IEntityNameValue[];

    /**
     * å¼ç¨å®ä½åç§°
     */
    refEntityName?: string;

    /**
     * å¯¹å¼ç¨å®ä½å±æ§ï¼è¡¨ç¤ºå¶IDå±æ§
     */
    refIdProp?: string;

    /**
     * å¯¹å¼ç¨å®ä½å±æ§ï¼è¡¨ç¤ºå¶åç§°å±æ§
     */
    refNameProp?: string;

    /**
     * åºç¨å®ä½ç¶ID
     */
    refParentId?: ID;
    //æ¯å¦å­ç¬¦ä¸²
    str?: boolean;
    //æ¯å¦æ°å­
    num?: boolean;
    //æ¯å¦æ¥æ
    date?: boolean;
    //æ¯å¦å¼ç¨
    ref?: boolean;
    //æ¯å¦æ©å±å±æ§
    extend?: boolean;
}
/**
 * åæ°æ®æ©å±å±æ§
 */
export interface IEntityMetadataExtra {
    attributeName?: string;
    attributeVal?: string;
}

export interface EntityMeta {
    /**
     * å®ä½åç§°ï¼é»è®¤ç±»åç§°(simple)
     */
    entityName?: string;

    /**
     * å®ä½åç§°ï¼ç¨äºæ¾ç¤º,é»è®¤å®ä½åç§°
     */
    entityTitle?: string;

    /**
     * å®ä½IDå±æ§åç§°,é»è®¤ï¼id
     */
    idProp?: string;

    /**
     * æ è¯å®ä½çå±æ§åç§°ï¼å¦æä¸ä¸ªå®ä½éè¦ç¨å¤ä¸ªå­æ®µæ¥æ è¯ï¼è¯·å®ä¹@Transientå­æ®µæ¥ç»è£
     */
    nameProp?: string;

    /**
     * æåºå­æ®µ,ä¸ºç©ºåç¨namePropæåº
     */
    sortProp?: string;

    /**
     * æç»åæ°æ®
     */
    detailMetadata?: EntityMeta;

    /**
     * æç»å­æ®µåç§°
     */
    detailPropname?: string;

    /**
     * ä¸»è¡¨å¼ç¨å±æ§
     */
    masterPropname?: string;

    /**
     * æ å½¢å®ä½ç¶èç¹å±æ§
     */
    parentProp?: string;

    /**
     * æ å½¢å®ä½ç¶èç¹å±æ§ç±»å: REF/C
     */
    parentPropType?: EntityPropType;

    /**
     * å±æ§åä¿¡æ¯åè¡¨
     */
    props?: EntityPropMetadata[];

    /**
     * æ©å±å±æ§
     */
    extraAttributes?: IEntityMetadataExtra[];
}